(function () {
	'use strict';

	angular
		.module('app')
		.directive('emailValidator', emailValidator);

	emailValidator.$inject = ['$window'];

	function emailValidator($window) {
		// Usage:
		//     <emailValidator></emailValidator>
		// Creates:
		// 
		var directive = {
			restrict: 'A',
			require: 'ngModel',
			link: link
		};
		return directive;

		function link($scope, $element, $attrs, $ctrl) {
			$ctrl.$parsers.unshift(function (value) {
				let isValid = true;
				let emailRegexPattern = /^\w+[\w-\.]*\@\w+((-\w+)|(\w*))\.[a-z]{2,3}$/;

				if (value) {
					isValid = emailRegexPattern.test(value);
					$ctrl.$setValidity('invalidEmail', isValid);

					return isValid ? value : "";
				} else {
					return isValid;
				}
			});
		}
	}
})();


//////////////////
// WEBPACK FOOTER
// ./static/common/js/validators/_emailValidator.js
// module id = 20
// module chunks = 0